import { VehicleListViewModel } from '@api/index';
import { useBreakpoint } from '@contexts/breakpoints';

import CarRentalListFiltersMobile from './mobile';
import CarRentalListFiltersDesktop from './desktop';
import { useCarRentalFilters } from '../hooks';

type Props = Pick<VehicleListViewModel, 'filters'>;

function CarRentalListFilters({ filters }: Props) {
  const { xl } = useBreakpoint();
  const filterProps = useCarRentalFilters(filters);

  return (
    <>
      {xl ? (
        <CarRentalListFiltersDesktop filters={filters} {...filterProps} />
      ) : (
        <CarRentalListFiltersMobile filters={filters} {...filterProps} />
      )}
    </>
  );
}

export default CarRentalListFilters;
